import { FontWeight, Heading, Text } from '../../tokens';
import { LiliButton, LiliButtonType } from '../LiliButton/LiliButton';
import { CloseButton, CloseButtonSize } from '../LiliCloseButton/CloseButton';
import { UserMessage } from '../LiliUserMessage/UserMessage';
import type { AlertModalProps } from './AlertModal.types';

export const AlertModal = (props: AlertModalProps) => {
  const {
    title,
    description,
    submitButtonTitle,
    cancelButtonTitle,
    onSubmit,
    onCancel,
    isLoading,
    isDisabled,
    submitButtonType = LiliButtonType.DESTRUCTIVE,
    isSmallTitle = false,
    children,
  } = props;

  const HeadingTag = isSmallTitle ? Heading.H8 : Heading.H5;
  return (
    <UserMessage onClick={onCancel} id='' contentWrapperClassName='px-[16px]'>
      <div className='flex flex-col bg-surface-primary-bw-01 rounded-[12px] animate-fadeIn p-[24px] w-full max-w-[468px] min-h-[190px] gap-[4px]'>
        <div className='absolute top-[12px] right-[12px]'>
          <CloseButton id='close_button' onClick={onCancel} circle size={CloseButtonSize.Medium} />
        </div>
        <HeadingTag
          fontWeight={FontWeight.MEDIUM}
          className='max-w-[400px] w-full overflow-hidden text-ellipsis'>
          {title}
        </HeadingTag>
        <div>
          {children ? (
            children
          ) : (
            <Text.H9 className='mb-[36px] text-text-main-secondary'>{description}</Text.H9>
          )}
          <div className='flex flex-row w-full gap-[14px] md:justify-end h-fit'>
            <div className='grow md:grow-0 md:min-w-[104px]'>
              <LiliButton
                id='cancel_button'
                title={cancelButtonTitle}
                onClick={onCancel}
                type={LiliButtonType.SECONDARY}
                className='h-[40px] w-full'
              />
            </div>
            <div className='grow md:grow-0 md:min-w-[104px]'>
              <LiliButton
                id='submit_button'
                title={submitButtonTitle}
                onClick={onSubmit}
                isLoading={isLoading}
                disabled={isDisabled || isLoading}
                type={submitButtonType}
                className='h-[40px] w-full'
              />
            </div>
          </div>
        </div>
      </div>
    </UserMessage>
  );
};
